import React, { Component, Children } from 'react'
import { connect } from 'react-redux'

import ReactCSSTransitionGroup from 'react-addons-css-transition-group'
import './images.css'

class Images extends Component {
  render() {
    const { children, current, icons } = this.props

    const images = Children.toArray(children).filter((child, index) => {
      return index === current
    })

    return (
      <ReactCSSTransitionGroup
        transitionName="image"
        transitionEnterTimeout={1500}
        transitionLeaveTimeout={1000}
        component="div"
        className={icons.answered ? 'images blur' : 'images'}
      >
        {images}
      </ReactCSSTransitionGroup>
    )
  }
}

const mapState = ({ icons }) => {
  return {
    icons
  }
}
export default connect(mapState)(Images)



// WEBPACK FOOTER //
// ./src/components/Images.js